export default __webpack_public_path__ + "static/media/Logo-Red.2571d78e.svg";